const colors = {
    primary: '#6041A1', 
    primaryLight: '#bca6f1',
    secondary: '#FFA109', 
    textMain: '#F8F8F8',
    textLink: '#FFF',
    parrafos: '#0D0D0D',
    parrafoLight: '#FFFAFA',
    error: '#C13050',
    primaryDegradado: '#8B6DD2',
    bgLight: '#fcfbff',
    bgPrimaryLight: '#8B6DD2',
    bgCircularProgressUnfinished: '#9EBCD6',
    bgDarkLight: '#E0E0E0',
    bgDifferenceUp: '#DDFEDD',
    bgDifferenceMedium: '#D4FBFE',
    bgDifferenceDown: '#FEDADA',
    underLine: '#DDD',
    blueGradient: '#C8CBFF',
    darkDisable: '#a6a6a6'
}

export default colors;
